import { createSelector } from '@ngrx/store';

import { globalSelector } from '@app/store/selectors/global.selector';
import { Global } from '@app/store/state/global.state';
import { HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';
import { mapAmenitiesForWidget, mapInfoPrice } from '@app/mappers/global-filters/hotel-global-filters.mapper';

export const getHotelFiltersState = createSelector(
  globalSelector,
  (state: Global) => state?.hotelFilters,
);

export const hotelsInfoPrice = createSelector(
  getHotelFiltersState,
  (state: HotelFiltersResponse) => mapInfoPrice(state?.MinPrice, state?.MaxPrice)
);

export const amenitiesForWidget = createSelector(
  getHotelFiltersState,
  (state: HotelFiltersResponse) => mapAmenitiesForWidget(state?.Ammenities)
);
